import tenantService from "../../services/tenantService";

export default {
  loadAll,
  load
};

function loadAll({ commit }) {
  return new Promise((resolve, reject) => {
    commit("setPendingStateChanges", 1);
    tenantService
      .getAll()
      .then(results => {
        results = sortTenants(results);
        commit("set", results);
        resolve(JSON.parse(JSON.stringify(results)));
      }, reject)
      .finally(() => {
        commit("setPendingStateChanges", -1);
      });
  });
}

function load({ commit }, id) {
  return new Promise((resolve, reject) => {
    commit("setPendingStateChanges", 1);
    tenantService
      .get(id)
      .then(result => {
        commit("update", result);
        resolve(JSON.parse(JSON.stringify(result)));
      }, reject)
      .finally(() => {
        commit("setPendingStateChanges", -1);
      });
  });
}

function sortTenants(arr) {
  return arr.sort((a, b) => {
    var test1 = a.name.toUpperCase();
    var test2 = b.name.toUpperCase();

    if (test1 < test2) return -1;
    if (test1 > test2) return 1;
    return 0;
  });
}
